module.exports = __webpack_public_path__ + "static/img/1.47bff77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/1.png
// module id = OLCu
// module chunks = 0